'use strict'

var Marionette = require('marionette')
var Backbone = require('backbone')
var App = require('app')
var _ = require('lodash')

var View = require('./view.js')
var BodyModel = require('src/common/page-model')

var ClientGroupsList = function (options) {
  var Controller = Marionette.Object.extend({
    initialize: function (options) {
      this.region = options.region
      this.client = options.client

      var self = this
      // // this.container = options.container
      self.groups = App.globalChannel.request('group:entities', {
        query: {
          client: self.client.get('_id')
        }
      })

      var bodyModel = new BodyModel({
        title: 'Groups',
        buttons: [
          { label: 'add group', primary: true, slug: 'node', action: 'client-groups:add', roles: ['super', 'admin'] }
        ]
      })

      self.layout = self.getLayoutView(bodyModel, self.groups)

      //  self.layout.on('childview:client-nodes:edit', _.bind(self.onEdit, self))
      self.listenTo(self.layout, 'client-groups:add', self.onAdd)
      self.listenTo(self.layout, 'childview:client-groups:edit', self.onEdit)

      self.listenTo(self.layout, 'render', function () {
        self.listRegion(self.groups)
      })
      self.region.show(self.layout)
      // App.rootLayout.showChildView('mainRegion', self.layout)
      //
      //
    },
    listRegion: function (collection) {
      var self = this
      //
      var columns = {
        // '_bulk': {
        //   'options': {
        //     'edit': {'label': 'Edit', 'roles': ['super', 'admin']},
        //     'delete': {'label': 'Delete', 'roles': ['super']}
        //   }
        // },
        'name': {'label': 'name', 'sortable': true, 'roles': [] },
        'type': {'label': 'type', 'sortable': true, 'roles': []},
        'devicesCount': {'label': 'devices', 'sortable': true, 'roles': [], 'hideSizes':['mobile']},
        'createdAt': {'label': 'created at', 'sortable': true, 'roles': [], 'hideSizes':['mobile']},
        '_actions': {
          'options': {
            'edit': { 'action': 'edit', 'roles': [] }
          }
        }
      }

      //
      var emptyViewModel = new Backbone.Model({
        title: 'No groups to show.',
        subTitle: 'create some groups to get started'
      })

      //
      var layout = this.getListView(collection, columns, emptyViewModel)
      self.listenTo(layout, 'listview:childview:item:edit', self.onEdit)
      self.listenTo(layout, 'listview:childview:item:manage', self.onManage)
      self.listenTo(layout, 'bulk:action', self.onBulk)

      self.layout.getRegion('listRegion').show(layout)
    },
    onBulk: function (args) {
      switch (args.bulk_action) {
        case 'delete':
          App.dialog.confirm({
            message: 'Are you sure you want to peform a bulk delete?',
            callback: function (confirmed) {
              if (confirmed) {
                args.collection.bulkDelete({})
              }
            }
          })
          break
        default:
          console.warn('Bulk action not catched by switch, "' + args.bulk_action + '"')
          break
      }
    },
    onEdit: function (args) {
      console.log(args)
      App.globalChannel.trigger('group:edit', {region: App.rootLayout.getRegion('dialogRegion'), model: args.model, collection: args.collection})
    },
    onAdd: function (args) {
      var self = this
      App.globalChannel.trigger('group:edit', {region: App.rootLayout.getRegion('dialogRegion'), collection: args.collection, client: self.client})

    // App.globalChannel.trigger('group:new', {region: App.rootLayout.getRegion('dialogRegion'), client: this.client, collection: this.devices})
    },
    // onShow: function (args) {
    //   App.globalChannel.trigger('client:show', {model: args.model})
    // },
    // onEdit: function (args) {
    //   App.globalChannel.trigger('client-nodes:edit', {region: App.rootLayout.getRegion('dialogRegion'), model: args.model})
    // },
    // getLayoutView: function (groups) {
    //   return new View.layout({collection: groups})
    // }
    getListView: function (nodes, columns, emptyViewModel) {
      // create the listview based on the list component
      return new View.listView({
        collection: nodes,
        columns: columns,
        emptyViewModel: emptyViewModel,
        childView: View.listItem // use a custom childview
      })
    },
    getLayoutView: function (model, collection) {
      return new View.layout({model: model, collection: collection})
    }
  })

  return new Controller(options)
}

module.exports = ClientGroupsList



// WEBPACK FOOTER //
// ./js/modules/client-groups/list/index.js